export const companyData = {
  name: 'AB-Informatik GmbH',
  tagline: 'Innovative IT-Lösungen für Ihre digitale Transformation',
  description: 'Maßgeschneiderte IT-Beratungsdienstleistungen zur Modernisierung Ihrer Infrastruktur und Beschleunigung Ihres Unternehmenswachstums.',
  
  services: [
    {
      id: 1,
      title: 'Managed IT-Services',
      description: 'Vollständige Verwaltung Ihrer IT-Systeme mit proaktivem Monitoring, Wartung und schnellem Support – für einen störungsfreien Betrieb.',
      icon: 'Server'
    },
    {
      id: 2,
      title: 'IT-Security & Compliance',
      description: 'Umfassende Sicherheitslösungen mit Schwachstellenscans, Firewall-Management und NIS2-Beratung für maximalen Schutz.',
      icon: 'Shield'
    },
    {
      id: 3,
      title: 'Cloud & Datacenter',
      description: 'Moderne Cloud-Lösungen, Backup-Services und Infrastructure-as-a-Service für flexible und skalierbare IT-Ressourcen.',
      icon: 'Cloud'
    },
    {
      id: 4,
      title: 'Modern Workplace',
      description: 'Digitale Arbeitsplätze mit Microsoft 365, Device-Management und mobilen Lösungen für produktives Arbeiten von überall.',
      icon: 'Laptop'
    },
    {
      id: 5,
      title: 'Netzwerk-Management',
      description: 'Network-as-a-Service mit kontinuierlicher Überwachung, Optimierung und professionellem Management Ihrer Netzinfrastruktur.',
      icon: 'GitBranch'
    },
    {
      id: 6,
      title: 'Cloud Telefonanlage',
      description: 'Moderne Cloud-basierte Telefonie mit flexibler Skalierung, ortsunabhängiger Erreichbarkeit und professionellen Kommunikationslösungen.',
      icon: 'Phone'
    },
    {
      id: 7,
      title: 'Interim IT-Management',
      description: 'Erfahrene IT-Manager auf Zeit für Projekte, Transformationen oder zur Überbrückung von Vakanzen – flexibel und kompetent.',
      icon: 'Users'
    },
    {
      id: 8,
      title: '24/7 Support',
      description: 'Rund-um-die-Uhr technischer Support mit schneller Reaktionszeit – vor Ort und remote für Ihre IT-Sicherheit.',
      icon: 'Headphones'
    },
    {
      id: 9,
      title: 'IT-Strategieberatung',
      description: 'Strategische IT-Beratung zur digitalen Transformation, Technologie-Roadmaps und Optimierung Ihrer IT-Landschaft für nachhaltigen Erfolg.',
      icon: 'Target'
    }
  ],
  
  stats: [
    { value: '500+', label: 'Abgeschlossene Projekte' },
    { value: '15+', label: 'Jahre Erfahrung' },
    { value: '200+', label: 'Zufriedene Kunden' },
    { value: '99.9%', label: 'Verfügbarkeitsgarantie' }
  ],
  
  contact: {
    email: 'info@ab-informatik.net',
    phone: '+49 2241 261310',
    address: 'Am Turm 26, 53721 Siegburg, Deutschland'
  },
  
  careers: {
    title: 'Karriere bei AB-Informatik',
    description: 'Werden Sie Teil unseres innovativen Teams und gestalten Sie die digitale Zukunft mit uns.',
    benefits: [
      {
        id: 1,
        title: 'Flexible Arbeitszeiten',
        description: 'Work-Life-Balance durch flexible Arbeitszeiten und modernes Arbeitsumfeld.',
        icon: 'Clock'
      },
      {
        id: 2,
        title: 'Weiterbildung',
        description: 'Zielgerichtete Weiterbildung und persönliche Entwicklungsmöglichkeiten.',
        icon: 'GraduationCap'
      },
      {
        id: 3,
        title: 'Spannende Projekte',
        description: 'Arbeiten Sie an hochkarätigen Projekten mit modernsten Technologien.',
        icon: 'Laptop'
      },
      {
        id: 4,
        title: 'Langfristige Perspektive',
        description: 'Sicherer Arbeitsplatz in einem gesunden mittelständischen Unternehmen.',
        icon: 'Users'
      }
    ],
    openPositions: [
      {
        id: 1,
        title: 'System Engineer (w/m/d)',
        location: 'Siegburg',
        type: 'Vollzeit',
        description: 'Planung und Installation komplexer EDV-Projekte mit Virtualisierungs- und Storage-Systemen.'
      },
      {
        id: 2,
        title: 'IT-Vertriebsunterstützung (w/m/d)',
        location: 'Siegburg',
        type: 'Vollzeit',
        description: 'Kundenbetreuung, Angebotserstellung und Unterstützung im Vertriebsprozess.'
      },
      {
        id: 3,
        title: 'Fachinformatiker Systemintegration (m/w/d) - Ausbildung',
        location: 'Siegburg',
        type: 'Ausbildung',
        description: 'Dreijährige Ausbildung mit umfassenden Kenntnissen in Systemintegration und Netzwerktechnik.'
      }
    ]
  }
};